// src/components/WhatsNew.jsx — one-time "what's new" panel per release.
// Features nobody knows about may as well not exist; this surfaces them once,
// then stays available from Account. Dismissal is per device (localStorage).
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CHANGELOG, LATEST_VERSION } from '../data/changelog';
import { IcX } from './Icons';

const SEEN_KEY = 'tt_whatsnew_seen';

export const hasUnseenWhatsNew = () => {
  try { return localStorage.getItem(SEEN_KEY) !== LATEST_VERSION; } catch { return false; }
};
export const markWhatsNewSeen = () => {
  try { localStorage.setItem(SEEN_KEY, LATEST_VERSION); } catch {}
};

// `force` opens it on demand (from Account); otherwise it self-opens once.
export default function WhatsNew({ force = false, onClose }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(force);
  const release = CHANGELOG[0];

  useEffect(() => {
    if (force) { setOpen(true); return; }
    // Delay slightly so it doesn't fight the page's first paint.
    const t = setTimeout(() => { if (hasUnseenWhatsNew()) setOpen(true); }, 1200);
    return () => clearTimeout(t);
  }, [force]);

  const close = () => { markWhatsNewSeen(); setOpen(false); onClose?.(); };
  const go = (link) => { close(); navigate(link); };

  if (!open || !release) return null;

  return (
    <div onClick={close} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9998, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'var(--white)', borderRadius: 16, maxWidth: 460, width: '100%', maxHeight: '85dvh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 24px 64px rgba(0,0,0,0.28)' }}>
        <div style={{ padding: '18px 20px 14px', borderBottom: '1px solid var(--nat-d)', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
          <div>
            <div style={{ fontSize: 10.5, fontWeight: 800, color: 'var(--org)', textTransform: 'uppercase', letterSpacing: '0.6px' }}>{release.date}</div>
            <div style={{ fontFamily: 'var(--display)', fontSize: 19, fontWeight: 800, color: 'var(--txt)', marginTop: 2 }}>{release.headline}</div>
          </div>
          <button onClick={close} aria-label="Close" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--txt-l)', padding: 4, display: 'flex', flexShrink: 0 }}><IcX size={17} /></button>
        </div>

        <div style={{ overflowY: 'auto', padding: '6px 20px 12px' }}>
          {release.items.map((it, i) => (
            <div key={i} style={{ padding: '13px 0', borderBottom: i < release.items.length - 1 ? '1px solid var(--nat-s)' : 'none' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--txt)', marginBottom: 3 }}>{it.title}</div>
              <div style={{ fontSize: 12.5, color: 'var(--txt-l)', lineHeight: 1.55 }}>{it.desc}</div>
              {it.link && (
                <button onClick={() => go(it.link)} style={{ marginTop: 7, background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'var(--org)', fontSize: 12.5, fontWeight: 800 }}>
                  {it.cta || 'Open'} →
                </button>
              )}
            </div>
          ))}
        </div>

        <div style={{ padding: '12px 20px 16px', borderTop: '1px solid var(--nat-d)' }}>
          <button className="btn btn-primary btn-md btn-full" onClick={close}>Got it</button>
        </div>
      </div>
    </div>
  );
}
